// Port aus StatusBadge.svelte — Zustandsmarke (Eingang, Verwaltung).
type Variant = 'pending' | 'needs_correction' | 'ok' | 'error' | 'neutral' | 'brand';
const KLASSEN: Record<Variant, string> = {
  pending:          'bg-amber-50 text-amber-800 border-amber-200',
  needs_correction: 'bg-orange-50 text-orange-800 border-orange-200',
  ok:               'bg-emerald-50 text-emerald-800 border-emerald-200',
  error:            'bg-rose-50 text-rose-800 border-rose-200',
  neutral:          'bg-gray-100 text-ps-dark-600 border-gray-200',
  brand:            'bg-primary-50 text-primary-800 border-primary-200',
};
const PUNKT: Record<Variant, string> = {
  pending: 'bg-amber-500', needs_correction: 'bg-orange-500', ok: 'bg-emerald-500',
  error: 'bg-rose-500', neutral: 'bg-ps-dark-400', brand: 'bg-primary-500',
};
export default function StatusBadge({ variant = 'neutral', label, dot = true, size = 'md' }:
  { variant?: Variant; label: string; dot?: boolean; size?: 'sm' | 'md' }) {
  return (
    <span className={`inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border font-medium ${KLASSEN[variant]} ${size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'}`}>
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${PUNKT[variant]}`} />}
      {label}
    </span>
  );
}
